import { useRoutes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import main from "reducer/rNavigate";

const Main = () => {
    const mainRoute = useRoutes(main);

    return (
        <div className="dark">
            {mainRoute}
        </div>
    );
};

export default Main;
